export const landingImages = [

    {
        url : 'landing/link.png',
        class : 'link'
    },
    {
        url : 'landing/mario.png',
        class : 'mario'
    },
    {
        url : 'landing/pikachu.png',
        class : 'pikachu'
    },
    {
        url : 'landing/squirtle.png',
        class : 'squirtle'
    },
    
    
]